import { render, staticRenderFns } from "./WishlistBlock.vue?vue&type=template&id=ef07bd12&"
import script from "./WishlistBlock.vue?vue&type=script&lang=js&"
export * from "./WishlistBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiLazyImg: require('/app/components/UI/UiLazyImg.vue').default})
